module.exports = __webpack_public_path__ + "static/media/minus.0a5bd634.svg";